import * as React from "react";
import { Icon } from "sb-resp-ui";
export const FavoritesIcon = (props) => React.createElement("div", { className: `rj-ev-list__fav-icon`, onClick: props.favoritesHandler, "data-uat": `ev-list-fav-icon` },
    React.createElement(Icon, { i: `i-12 i-o-fav i-o-fav-row ${props.isInFavorites ? "i-o-fav-selected" : ""}` }));
//# sourceMappingURL=FavoritesIcon.js.map